export const styleConfig = {
  node: {
    width: 200,
    padding: 8
  },
  alias: {
    height: 30,
    lineHeight: "24px"
  },
  contentGroup: {
    marginBottom: 10
  },
  contentDivider: {
    height: 24,
    lineHeight: "24px"
  },
  contentItem: {
    height: 28,
    lineHeight: "28px",
    marginBottom: 7
  }
};
